import { useLayoutEffect } from "react"

import { Link, NavigateFunction, useNavigate } from "react-router-dom"

import { TUserState, useUser } from "@/3514/hooks"
import { INDEX_URL } from "@/constants"

import { ErrorPage } from "./ErrorPage"

export const ForbiddenComponent = () => {
    const { isLoaded: isUserLoaded }: TUserState = useUser()

    const navigate: NavigateFunction = useNavigate()

    useLayoutEffect((): void => {
        if (isUserLoaded) navigate(INDEX_URL)
    }, [isUserLoaded, navigate])

    return (
        <ErrorPage
            errorContent={
                <div className="text-center">
                    <span className="font-extrabold color-gray">Access Denied.</span>{" "}
                    <br className="d-block d-md-none" />
                    <Link to="/" className="color-brand font-bold">
                        Back to dashboard
                    </Link>
                </div>
            }
        />
    )
}
